export default "__VITE_ASSET__CTJRExpJ__"